import axios from "@/services/api-client";
import {
  CreateVariableRequest,
  UpdateVariableRequest,
  VariableKind,
  VariablePublic,
  VariableSource,
  VariableSources,
  VariableValueType,
  VaultTestRequest,
  VaultTestResult,
} from "./variableShape";

// Re-export under the legacy ``Group*`` names so existing call sites
// keep working without churn. The shape itself is shared with the
// workflow-scoped service — see ``./variableShape.ts``.
export type GroupVariableKind = VariableKind;
export type GroupVariableValueType = VariableValueType;
export type GroupVariableSource = VariableSource;
export type GroupVariablePublic = VariablePublic;
export type CreateGroupVariableRequest = CreateVariableRequest;
export type UpdateGroupVariableRequest = UpdateVariableRequest;

function base(groupId: string): string {
  return `/api/backend/groups/${groupId}/variables`;
}

export const GroupVariablesService = {
  async list(groupId: string): Promise<GroupVariablePublic[]> {
    const res = await axios.get<{ variables: GroupVariablePublic[] }>(
      base(groupId)
    );
    return res.data.variables;
  },

  async sources(groupId: string): Promise<VariableSources> {
    const res = await axios.get<VariableSources>(`${base(groupId)}/sources`);
    return res.data;
  },

  async create(
    groupId: string,
    req: CreateGroupVariableRequest
  ): Promise<GroupVariablePublic> {
    const res = await axios.post<GroupVariablePublic>(base(groupId), req);
    return res.data;
  },

  async update(
    groupId: string,
    variableId: string,
    req: UpdateGroupVariableRequest
  ): Promise<GroupVariablePublic> {
    const res = await axios.patch<GroupVariablePublic>(
      `${base(groupId)}/${variableId}`,
      req
    );
    return res.data;
  },

  async remove(groupId: string, variableId: string): Promise<void> {
    await axios.delete(`${base(groupId)}/${variableId}`);
  },

  async testVault(
    groupId: string,
    req: VaultTestRequest
  ): Promise<VaultTestResult> {
    const res = await axios.post<VaultTestResult>(
      `${base(groupId)}/test-vault`,
      req
    );
    return res.data;
  },
};
